module.exports = __webpack_public_path__ + "img/full6-min.347900f5.png";